<template>
  <div>
    <Navbar activeDirectory="storico" activePage="segnalazioni"></Navbar>
    <div class="container-fluid">
      <div class="row" v-if="segnalazione.deleted">
        <div class="col">
          <div
            class="alert alert-danger"
          >Questa segnalazione è stata eliminata, pertanto non è presente nei report e nelle statistiche. <button class="btn btn-success btn-sm btn-danger ml-2" @click="confirmReopen()">Ripristina segnalazione</button></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6 mb-3 mb-lg-0">
          <div class="card">
            <h4 class="card-header font-bold text-uppercase">
              <small>Segnalazione,</small>
              {{ nomeIntervento(segnalazione.intervento, interventi) }}
              <small>presso</small>
              {{ segnalazione.strada }}
            </h4>
            <div class="card-body">
              <form type="multipart/form-data" ref="editForm" @submit.prevent="confirmNewRevision">
                <div class="table-responsive">
                  <table class="table table-striped border">
                  <tbody>
                    <tr>
                      <th>ID Segnalazione</th>
                      <td class="text-left font-weight-bold text-muted">#{{ segnalazione.id }}</td>
                    </tr>
                    <tr>
                      <th>Intervento</th>
                      <td>
                        <select
                          style="width: 100%; border: 0; background: transparent; font-weight: 600;"
                          name="intervento"
                          v-model="segnalazione.intervento"
                        >
                          <option v-for="item in interventi" :key="item.id" :value="item.codice">{{ item.nome }}</option>
                          <option v-if="segnalazione.intervento && !interventi.find(i => i.codice === segnalazione.intervento)" :value="segnalazione.intervento">{{ nomeIntervento(segnalazione.intervento, interventi) }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>Revisione</th>
                      <td class="text-left" v-if="segnalazione.version>0">Revisione n.{{ segnalazione.version }}</td>
                      <td class="text-left" v-else>Versione originale</td>
                    </tr>
                    <tr>
                      <th>Team</th>
                      <td class="text-left">{{ segnalazione.team_segnalatore.nome }}</td>
                    </tr>
                    <tr>
                      <th>Segnalato in data</th>
                      <td class="text-left">{{ formatTimestampToLocalDate(segnalazione.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td class="text-left">{{ segnalazione.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td
                        class="text-left"
                      >{{ segnalazione.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td
                        class="text-left"
                      >{{ segnalazione.longitudine }}</td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>
                        <input
                          style="width: 100%; border: 0; background: transparent; font-weight: 600;"
                          name="note"
                          v-model="segnalazione.note"
                          type="text"
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>Foto</th>
                      <td>
                        <img
                          :src="segnalazione.foto"
                          style="max-height: 360px; max-width: 100%; cursor: pointer;"
                          @click="showFotoUploader=!showFotoUploader;"
                          v-if="!showFotoUploader"
                        />
                        <br />
                        <span class="badge badge-primary">Foto</span>
                        <i
                          class="fa fa-pencil ml-2"
                          @click="showFotoUploader=!showFotoUploader;"
                          style="cursor: pointer;"
                        ></i>
                        <br v-if="showFotoUploader" />
                        <input
                          v-if="showFotoUploader"
                          @change="processFoto($event)"
                          type="file"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
              <br />
              <button class="btn btn-primary" @click="confirmNewRevision()" v-if="!segnalazione.deleted">Nuova revisione</button>
              <button
                class="btn btn-danger ml-2"
                @click="confirmDeletion()"
                v-if="!segnalazione.deleted"
              >Elimina segnalazione</button>
              
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="card">
            <h4 class="card-header font-bold text-uppercase">
              <small>Storico delle</small> revisioni
            </h4>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover border">
                <thead class="thead-light">
                  <th>Revisione n.</th>
                  <th>Revisore</th>
                  <th>Data</th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in revisioni"
                    v-bind:key="item.id"
                    style="cursor: pointer;"
                    :class="[{'bg-secondary text-white font-bold':revisioneSelected==item.version}]"
                    @click="lavoro=JSON.parse(JSON.stringify(item));showFotoUploader=false;revisioneSelected=item.version;"
                  >
                    <td v-if="item.version > 0">Revisione n. {{ item.version }}</td>
                    <td v-else>Versione originale</td>
                    <td v-if="item.version > 0">{{ item.editor.nome }}</td>
                    <td v-else>-</td>
                    <td v-if="item.version > 0">{{ formatTimestampToLocalDate(item.update_time) }}</td>
                    <td v-else>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar } from "@/components";
import { nomeIntervento } from "@/utils/intervento";

export default {
  components: {
    Navbar,
  },

  data() {
    return {
      segnalazione: {
        team: {},
        team_segnalatore: {}
      },
      revisioni: [],
      revisioneSelected: 0,
      ultimaRevisione: 0,
      showFotoUploader: false,
      foto: null,
      interventi: []
    };
  },

  mounted() {
    if (localStorage.getItem("tipologia") != "B") {
      this.$router.push({ name: "home" });
    }

    this.fetchData();
    this.fetchInterventions();
  },

  methods: {
    nomeIntervento,

    fetchData() {
      this.axios
        .get(`notice/${this.$route.params.uuid}/versions`)
        .then((response) => {
          this.revisioni = response.data;
          this.segnalazione = response.data[0];
          this.revisioneSelected = this.segnalazione.version;
          this.ultimaRevisione = this.segnalazione.version;
          this.fetchInterventions();
        });
    },

    fetchInterventions() {
      this.axios.get('my-interventions').then((response) => {
        this.interventi = Array.isArray(response.data) ? response.data : [];
      });
    },

    // confirmNewRevision
    //
    // Use sweet-alert to confirm
    confirmNewRevision() {
      if(this.segnalazione.deleted) {
        return
      }
      this.$swal
        .fire({
          title: "Nuova revisione",
          text: "Procedendo verrà creata una nuova revisione per questa segnalazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, genera",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("version", this.ultimaRevisione);
            formData.append("intervento", this.segnalazione.intervento);
            formData.append("note", this.segnalazione.note);
            formData.append("foto", this.foto);
            this.axios
              .put(`notice/${this.$route.params.uuid}/versions`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmDeletion
    //
    // Use sweet-alert to confirm
    confirmDeletion() {
      this.$swal
        .fire({
          title: "Elimina segnalazione",
          text:
            "Procedendo verrà eliminata questa segnalazione che non sarà più presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, elimina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "true");
            this.axios
              .put(`notice/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // confirmReopen
    //
    // Use sweet-alert to confirm
    confirmReopen() {
      this.$swal
        .fire({
          title: "Ripristina segnalazione",
          text:
            "Procedendo verrà ripristinata questa segnalazione che sarà nuovamente presente nei report",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sì, ripristina",
          cancelButtonText: "Annulla",
        })
        .then((result) => {
          if (result.value) {
            let formData = new FormData();
            formData.append("del_status", "false");
            this.axios
              .put(`notice/${this.$route.params.uuid}/delete`, formData)
              .then((response) => {
                if (response.data["success"]) {
                  this.$router.go();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    text: "Errore inatteso",
                  });
                }
              });
          }
        });
    },

    // processFoto
    //
    // Used for upload image
    processFoto(event) {
      var target = event.target.files[0];
      this.foto = target;
    },

    classeInterventoBadge(intervento) {
      if (!intervento) return 'badge-secondary';
      const lower = typeof intervento === 'string' ? intervento.toLowerCase() : String(intervento).toLowerCase();
      if (lower.includes('buca')) {
        return 'badge-success';
      }
      if (lower.includes('sfalcio')) {
        return 'badge-primary';
      }
      if (lower.includes('segnaletica')) {
        return 'badge-dark';
      }
      if (lower.includes('rifiuto_speciale')) {
        return 'badge-purple';
      }
      if (lower.includes('rifiuto')) {
        return 'badge-warning';
      }
      if (lower.includes('emergenza') || lower.includes('palo')) {
        return 'badge-danger';
      }
      if (lower.includes('pulizia') || lower.includes('cestino')) {
        return 'badge-secondary';
      }
      return 'badge-secondary';
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts) {
      if (ts) {
        const today = new Date();
        var tsDate = new Date(ts * 1000);
        if (
          today.getDate() == tsDate.getDate() &&
          today.getMonth() == tsDate.getMonth() &&
          today.getFullYear() == tsDate.getFullYear()
        ) {
          return `Oggi, ${tsDate.toLocaleTimeString()}`;
        } else {
          return tsDate.toLocaleString();
        }
      } else {
        return "-";
      }
    },
  },
};
</script>

<style>
td {
  text-align: center;
  vertical-align: middle;
}
</style>